import { ItemModel } from "lib/services/catalogical-models";

export enum Visibility {
  PRIVATE = "private",
  PUBLIC = "public",
  SHARED = "shared",
}

export interface ListItem extends ItemModel {
  addedAt: Date;
  addedBy: string;
  status: string;
}

export interface ListModel extends ItemModel {
  name: string;
  description: string;
  ownerAlias: string;
  items: ListItem[];
  itemCount: number;
  visibility: Visibility;
}
